/* global axios */
import BotifyAPI from 'dashboard/api/BotifyAPI';

class AppError extends Error {
  constructor(code, params = {}, original = null) {
    super(code);
    this.code = code;
    this.params = params;
    this.original = original;
  }
}

const normalizeBotifyToolsError = error => {
  if (error instanceof AppError) return error;

  const status = error?.response?.status;

  // Based on your backend contract:
  // 409 => duplicate name, 404 => tool not found
  if (status === 409) {
    return new AppError('BOTIFY/DUPLICATE_TOOL_NAME', {}, error);
  }

  if (status === 404) {
    return new AppError('BOTIFY/TOOL_NOT_FOUND', {}, error);
  }

  return error;
};

class BotifyTools extends BotifyAPI {
  constructor() {
    super('botify', { accountScoped: true });
  }

  async getTools() {
    const guard = this.ensureConfigured();
    if (guard) return guard;
    try {
      return await axios.get(`${this.baseUrl()}/tools/`);
    } catch (e) {
      throw normalizeBotifyToolsError(e);
    }
  }

  async createTool(data) {
    const guard = this.ensureConfigured();
    if (guard) return guard;
    try {
      return await axios.post(`${this.baseUrl()}/tools/`, data);
    } catch (e) {
      throw normalizeBotifyToolsError(e);
    }
  }

  async updateTool(data) {
    const guard = this.ensureConfigured();
    if (guard) return guard;
    try {
      return await axios.put(`${this.baseUrl()}/tools/`, data);
    } catch (e) {
      throw normalizeBotifyToolsError(e);
    }
  }

  async deleteTool(data) {
    const guard = this.ensureConfigured();
    if (guard) return guard;
    try {
      return await axios.delete(`${this.baseUrl()}/tools/`, { data });
    } catch (e) {
      throw normalizeBotifyToolsError(e);
    }
  }
}

export default new BotifyTools();
export { AppError };
